module.exports = "<div class=\"weui_cell\">\n  <cell-header><slot name=\"header\"></slot></cell-header>\n  <cell-body><slot name=\"body\"></slot></cell-body>\n  <cell-footer><slot name=\"footer\"></slot></cell-footer>\n</div>";


/*****************
 ** WEBPACK FOOTER
 ** ./~/vue-html-loader!./~/vue-loader/lib/selector.js?type=template&index=0!./components/cells/cell.vue
 ** module id = 70
 ** module chunks = 0
 **/